import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/api';
import { Select } from 'primeng/select';
import { en, es, fr, kk, nl, pt, ru } from '#locale';
import { UpperCasePipe } from '@angular/common';

@Component({
  selector: 'app-language-picker',
  imports: [FormsModule, TranslatePipe, Select, UpperCasePipe],
  templateUrl: './language-picker.component.html',
  styleUrl: './language-picker.component.scss',
})
export class LanguagePicker {
  selectedLanguage: string;

  private readonly _translateService = inject(TranslateService);

  readonly languagesList: SelectItem[] = [];

  constructor() {
    const currentLang = localStorage.getItem('currentLang') || 'en';
    this.selectedLanguage = currentLang;
    this._translateService.use(currentLang);

    const translations = { en, es, fr, kk, nl, pt, ru };
    this.languagesList = Object.entries(translations).map<SelectItem<string>>(([lang, dict]) => ({
      value: lang,
      label: dict[lang] as string,
    }));
  }

  setLang($event: string) {
    this.selectedLanguage = $event;
    this._translateService.use($event);
    localStorage.setItem('currentLang', $event);
  }
}
